<template>
  <div v-if="isReady">
    <ElmPreview :ports="setupPorts" :flags="flags"></ElmPreview>
  </div>
</template>

<script>
  import Preview from "@/components/Preview.elm";
  import * as WrapElm from "@/components/utils/elmWrapper.js";
  import services from "@/services";
  import { mapState } from "vuex";
  import i18n from "@/plugins/i18n";

  export default {
    name: "Preview",
    data() {
      return {
        flags: {},
        isReady: null
      };
    },
    props: {
      deId: String
    },
    computed: {
      ...mapState({
        messages: "messages",
        user: "user"
      }),
      i18nMessages() {
        const i18Messages = i18n.messages;
        const locale = i18n.locale || "en_US";
        const defaultMessages = i18Messages[i18n.fallbackLocale] || i18Messages.en || {};
        const messages = i18Messages[locale] || i18Messages[locale.split("_")[0]] || {};
        return {...defaultMessages, ...messages};
      }
    },
    mounted() {
      this.flags = {
        type: "Data",
        uuid: this.deId,
        veevaMessages: this.messages,
        i18n : this.i18nMessages
      };

      this.isReady = true;
    },
    components: { ElmPreview: WrapElm(Preview.Elm.Preview) },
    methods: {
      setupPorts: ports => {
        ports.sendToEngine.subscribe(
          services.getElmCompiler().ports.rxFromPreview.send
        );
        services
          .getElmCompiler()
          .ports.sendToPreview.subscribe(ports.rxFromEngine.send);
      }
    }
  };
</script>

<style scoped></style>
